import React, { Suspense } from "react";
import Card from "../UI/Card";
import PageLoader from "../UI/PageLoader";

// Use the same LoadingDisplay as RouteLoader
const LoadingDisplay = () => (
  <Card classNames="p-6 lg:mt-10">
    <PageLoader />
  </Card>
);

// Hybrid helper that automatically detects component type
export const withSuspense = (Component, LoadingComponent = LoadingDisplay) => {
  // If Component is a function that returns JSX (like in RouteLoader)
  if (typeof Component === "function" && Component.length > 0) {
    return <Suspense fallback={<LoadingComponent />}>{Component()}</Suspense>;
  }
  // If Component is already JSX (like in RouteLoader cases)
  if (React.isValidElement(Component)) {
    return <Suspense fallback={<LoadingComponent />}>{Component}</Suspense>;
  }
  // If Component is a React component
  return (
    <Suspense fallback={<LoadingComponent />}>
      <Component />
    </Suspense>
  );
};
